
import { Options, Vue } from 'vue-class-component'
import PlaceModel from '@/models/PlaceModel'

@Options({
  props: {
    place: Object
  }
})
export default class CarouselItem extends Vue {
  place!: PlaceModel
}
